import { render, staticRenderFns } from "./MatrixQuestion.vue?vue&type=template&id=74cc851e&scoped=true"
import script from "./MatrixQuestion.vue?vue&type=script&lang=js"
export * from "./MatrixQuestion.vue?vue&type=script&lang=js"
import style0 from "./MatrixQuestion.vue?vue&type=style&index=0&id=74cc851e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc851e",
  null
  
)

export default component.exports